import Dashboard from "../Dashboard/Dashboard";
import TopBar from "../../components/Layout/TopBar";


const Home = () => {
  return (
    <>
      <TopBar />
      <Dashboard />
    </>
  );
};

export default Home;